// The outline drawn around an item on the canvas belongs to the moodboard--outline Stimulus
// controller, which owns the SVG paths and the set of ids currently outlined. It is driven
// entirely by these two events, so anything that wants an outline asks for one rather than
// drawing it.
//
// Most of the editor still dispatches these events inline; these helpers exist so callers that
// draw outlines the user is actively dragging around do not each reinvent the payload.

export function removeOutline(itemId) {
  document.dispatchEvent(new CustomEvent('removeOutline', { detail: { itemId } }));
}

// Clears whatever is drawn under this id first, so an outline can follow a moving item without
// the stale path sticking around.
//
// Give it either an `item` to measure or `corners` already measured — the latter lets one
// measurement feed several consumers, so they cannot disagree about where the item is. Corners
// account for item scale, rotation and board zoom.
export function createOutline(itemId, { item, corners, classes } = {}) {
  removeOutline(itemId);
  document.dispatchEvent(
    new CustomEvent('createOutline', {
      detail: {
        itemId,
        itemCorners: corners ?? window.ed._interaction.getCornersCoordinates(item),
        classes,
      },
    })
  );
}
